// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-container {
  width: 100%;
  height: fit-content;
  max-height: 100%;
  position: relative;
  background-color: var(--m-card-background-color);
  box-shadow: var(--m-box-shadow-card);
  border-radius: var(--m-border-radius);
  padding: 10px;
  -webkit-user-select: none;
  user-select: none;
}
.calendar-container__header {
  display: flex;
  flex-direction: column;
  cursor: default;
  color: var(--m-text);
}
.calendar-container__header .header-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  margin-bottom: 10px;
  padding: 0 10px;
  white-space: nowrap;
}
.calendar-container__header .header-controls__buttons {
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  -webkit-user-select: none;
  user-select: none;
}
.calendar-container__header .header-controls__buttons:hover {
  background-color: var(--m-subtle-card-background-color);
}
.calendar-container__header .header-controls__buttons svg {
  cursor: pointer;
  color: var(--m-icon-color);
}
.calendar-container__header .header-controls__buttons--disabled {
  pointer-events: none;
  opacity: 0.5;
}
.calendar-container__header .weekly-days {
  display: flex;
}
.calendar-container__header .weekly-days .day {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1;
  height: 34px;
  color: var(--m-text-light);
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}
.calendar-container__content {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}
.calendar-container__content .week {
  display: flex;
  flex-direction: row;
  box-sizing: content-box;
  gap: 7px;
}
.calendar-container__content .week:first-child {
  border-top: none;
}
.calendar-container__content .week .day {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1;
  cursor: pointer;
  font-size: 13px;
  border: 1.5px solid transparent;
  color: var(--m-text);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
}
.calendar-container__content .week .day::before {
  content: "";
  width: 35px;
  height: 35px;
  position: absolute;
  border-radius: 50%;
  background-color: transparent;
}
.calendar-container__content .week .day.another-month {
  font-weight: normal;
  color: var(--m-subtle-xbolder);
}
.calendar-container__content .week .day:hover:not(.today)::before {
  color: #0a1811;
  z-index: -1;
}
.calendar-container__content .week .day.today {
  position: relative;
  color: white;
}
.calendar-container__content .week .day.today::after {
  content: "";
  width: 35px;
  height: 35px;
  position: absolute;
  z-index: -1;
  background-color: var(--m-primary);
  border-radius: 50%;
  color: #0a1811;
}
.calendar-container__content .week .day.selected {
  position: relative;
  color: white;
}
.calendar-container__content .week .day.selected::after {
  content: "";
  width: 35px;
  height: 35px;
  position: absolute;
  z-index: -1;
  background-color: var(--m-primary);
  border-radius: 50%;
}
.calendar-container__content .week .day.unselectable-dates {
  color: #9e9e9e;
  cursor: not-allowed;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/Calendar/Calendar.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EAGA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gDAAA;EACA,oCAAA;EACA,qCAAA;EACA,aAAA;EACA,yBAAA;EAGA,iBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AACN;AACM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EAGA,iBAAA;AACR;AACQ;EACE,uDAAA;AACV;AAEQ;EACE,eAAA;EACA,0BAAA;AAAV;AAGQ;EACE,oBAAA;EACA,YAAA;AADV;AAMI;EACE,aAAA;AAJN;AAMM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAJR;AASE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;AAPJ;AASI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAPN;AASM;EACE,gBAAA;AAPR;AAUM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,+BAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;AARR;AAUQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;AARV;AAWQ;EACE,mBAAA;EACA,8BAAA;AATV;AAaU;EACE,cAAA;EACA,WAAA;AAXZ;AAeQ;EACE,kBAAA;EACA,YAAA;AAbV;AAeU;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,kCAAA;EACA,kBAAA;EACA,cAAA;AAbZ;AAiBQ;EACE,kBAAA;EACA,YAAA;AAfV;AAiBU;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,kCAAA;EACA,kBAAA;AAfZ;AAmBQ;EACE,cAAA;EACA,mBAAA;EACA,oBAAA;AAjBV","sourcesContent":[".calendar-container {\n  width: 100%;\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  max-height: 100%;\n  position: relative;\n  background-color: var(--m-card-background-color);\n  box-shadow: var(--m-box-shadow-card);\n  border-radius: var(--m-border-radius);\n  padding: 10px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  &__header {\n    display: flex;\n    flex-direction: column;\n    cursor: default;\n    color: var(--m-text);\n\n    .header-controls {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      height: 40px;\n      margin-bottom: 10px;\n      padding: 0 10px;\n      white-space: nowrap;\n\n      &__buttons {\n        cursor: pointer;\n        width: 30px;\n        height: 30px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 50%;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n\n        &:hover {\n          background-color: var(--m-subtle-card-background-color);\n        }\n\n        svg {\n          cursor: pointer;\n          color: var(--m-icon-color);\n        }\n\n        &--disabled {\n          pointer-events: none;\n          opacity: 0.5;\n        }\n      }\n    }\n\n    .weekly-days {\n      display: flex;\n\n      .day {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex: 1;\n        height: 34px;\n        color: var(--m-text-light);\n        font-size: 12px;\n        font-weight: 500;\n        text-transform: uppercase;\n      }\n    }\n  }\n\n  &__content {\n    margin-top: 10px;\n    display: flex;\n    flex-direction: column;\n\n    .week {\n      display: flex;\n      flex-direction: row;\n      box-sizing: content-box;\n      gap: 7px;\n\n      &:first-child {\n        border-top: none;\n      }\n\n      .day {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex: 1;\n        cursor: pointer;\n        font-size: 13px;\n        border: 1.5px solid transparent;\n        color: var(--m-text);\n        border-radius: 50%;\n        width: 40px;\n        height: 40px;\n        box-sizing: border-box;\n        position: relative;\n        z-index: 1;\n\n        &::before {\n          content: \"\";\n          width: 35px;\n          height: 35px;\n          position: absolute;\n          border-radius: 50%;\n          background-color: transparent;\n        }\n\n        &.another-month {\n          font-weight: normal;\n          color: var(--m-subtle-xbolder);\n        }\n\n        &:hover:not(.today) {\n          &::before {\n            color: #0a1811;\n            z-index: -1;\n          }\n        }\n\n        &.today {\n          position: relative;\n          color: white;\n\n          &::after {\n            content: \"\";\n            width: 35px;\n            height: 35px;\n            position: absolute;\n            z-index: -1;\n            background-color: var(--m-primary);\n            border-radius: 50%;\n            color: #0a1811;\n          }\n        }\n\n        &.selected {\n          position: relative;\n          color: white;\n\n          &::after {\n            content: \"\";\n            width: 35px;\n            height: 35px;\n            position: absolute;\n            z-index: -1;\n            background-color: var(--m-primary);\n            border-radius: 50%;\n          }\n        }\n\n        &.unselectable-dates {\n          color: #9e9e9e;\n          cursor: not-allowed;\n          pointer-events: none;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
